<template>
  <div class="landing-modal">
    <video
      class="landing-modal__video"
      controls="controls"
      autoplay>
      <source
        src="https://storage.yandexcloud.net/onti-public/media/%D0%9F%D1%83%D0%B1%D0%BB%D0%B8%D1%87%D0%BD%D1%8B%D0%B5%20%D1%84%D0%B0%D0%B9%D0%BB%D1%8B/%D0%9D%D0%A2%D0%9E%202627/%D0%A1%D1%82%D0%B0%D1%80%D1%82%20%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%86%D0%B8%D0%B8.mp4"
        type="video/mp4" />
    </video>
  </div>
</template>

<script>
export default {
  name: "LandingModal",
};
</script>

<style lang="less" scoped>
.landing-modal {
  &__video {
    width: 100%;
  }
}
</style>
